import { useQuery } from '@tanstack/react-query';
import { fetchCollectCdfFile } from '@/integrations/mtrManager/client';

export function useCollectCdfFile(collectId: string | null) {
  return useQuery({
    queryKey: ['collect-cdf-file', collectId],
    queryFn: () => fetchCollectCdfFile(collectId!),
    enabled: !!collectId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
